module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timers"
  }, [_c('div', {
    staticClass: "past-time"
  }, [_c('div', {
    attrs: {
      "id": "timerset"
    }
  }, [_vm._v("Past Time")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "timerset bottom"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.pastTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "remaining-time"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Remaining Time")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px !important",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.remainingTime))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd671cac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RemainingTime.vue
// module id = 1712
// module chunks = 2